"use client"
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react"; 
import "swiper/css";
import "swiper/css/navigation";
// import styles from "../page.module.css"
// import Link from "next/link";
import Stars from "../../../public/stars.svg"
import Image from "next/image";
import { Autoplay } from "swiper/modules";  // Removed the Navigation import

const items = [
  {
    name: "Zy Elmore",
    text: "I started using Temok when I was in the market for a reliable server for my business. They were able to provide me a domain name and website for a discounted price&hellip;", 
    icon: Stars,
  },
  {
    name: "Uttoran Sen",
    text: "Using Temok for a very long time now, moved from another host because they weren&rsquo;t able to keep my website clean from attacks&mdash;now with Temok, the past few years have gone very smoothly without having to worry about technical stuff etc.",
    icon: Stars,
  },
  {
    name: "Pavel Chintea",
    text: "I am using their services for more than 1 year. So far no issue. When I have some questions, customer support is helping me. Answers are fast and&hellip;", 
    icon: Stars,
  },
  {
    name: "Zy Elmore",
    text: "I started using Temok when I was in the market for a reliable server for my business. They were able to provide me a domain name and website for a discounted price&hellip;", 
    icon: Stars,
  },
  {
    name: "Uttoran Sen",
    text: "Using Temok for a very long time now, moved from another host because they weren&rsquo;t able to keep my website clean from attacks&mdash;now with Temok, the past few years have gone very smoothly without having to worry about technical stuff etc.",
    icon: Stars,
  },
];

const TestimonialsSection: React.FC = () => {
  return (
    <section id="testimonials-section" className="container-lg py-5 mt-lg-5 text-white">
      <h1 className="fw-bold display-5 text-center textHad">
      What Clients Say About Us
      </h1>
      <p className="textPara text-center fw-normal fs-5">Your trusted hosting partner since 2002. Here is what some of our customers say about temok.com</p>
      <Swiper
        className="mt-4 px-4"
        modules={[Autoplay]}  // Only Autoplay is included
        spaceBetween={30}
        slidesPerView={1}
        autoplay={{
          delay: 2000,
        }}
        breakpoints={{
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 4,
          },
        }}
      >
        {items.map((item, i) => (
          <SwiperSlide key={i} className="py-2">
            <div key={i} className="  blogBord hvr-sink">  
              <p className="fs-6 fw-normal textPara lh-base textHeight">{item.text}</p>
              <h6 className="textHad fw-bold fs-5">
                {item.name}
              </h6>
              <Image src={item.icon} width={100} alt="..."/>
            </div>
          </SwiperSlide>
        ))}
      </Swiper> 
    </section>
  );
};

export default TestimonialsSection;
